import { Pipe, PipeTransform } from '@angular/core';
import { AuthenticationService } from '@app/core';

@Pipe({
  name: 'campaignCode',
})
export class CampaignCodePipe implements PipeTransform {
  constructor(private authService: AuthenticationService) {}
  transform(val: string): string {
    const clientCampaigns = this.authService.getAllClientCampaigns();
    if (clientCampaigns != null && clientCampaigns.length > 0) {
      const campaign = clientCampaigns.filter((x: any) => x.Name == val);
      if (!campaign || campaign.length == 0) return val;

      return campaign[0].Code;
    }
    return val;
  }
}
